import { useCallback, useEffect, useState } from 'react'

import { OLMSApiService } from '@/shared/apis'
import { useAppSelector } from '@/shared/store'

export type Break = {
  ShiftBreakId: number
  RunsheetName: string
  Run: string
  PlannedArrival: string 
  StatusDescription: 'On Break' | 'Not Taken' | 'Completed' | 'Unplanned'
  IsLate: boolean
  ViolationMinLate: number
  BreakStart: string
  BreakFinish: string
  ShiftId: number
}

export const useBreaksData = () => {
  const activeGroupId = useAppSelector(state => state.userInterface.activeGroupId)
  const [breaks, setBreaks] = useState<Break[]>([])
  const [loading, setLoading] = useState(false)

  const fetchBreaks = useCallback(async () => {
    setLoading(true)

    try {
      const data = await OLMSApiService.get<Break[]>(`/BreakPanel/reportdata/${activeGroupId}`)

      setBreaks(data || [])
    } catch (error) {
      console.error('Error fetching breaks:', error)
    }

    setLoading(false)
  }, [activeGroupId])

  useEffect(() => {
    fetchBreaks()
  }, [fetchBreaks, activeGroupId])

  return {
    loading,
    breaks,
    setBreaks,
    refreshBreaks: fetchBreaks,
  }
}
